


























































































































































































import { fetchControl } from '../fetchControl';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    DatePicker,
  },
})
export default class General extends ComponenteBaseStepper {
  @Prop({ required: true }) editedItem: any;
  @Prop({ required: true }) editedItemCliente: any;

  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];

  async getSolicitud() {
    let self = this;
    this.loadingService.showLoading();
    return fetchControl(
      {
        solicitud: this.editedItem,
        cliente: this.editedItemCliente,
      },
      'conecta_consulta_control_baja_cliente/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las solicitudes', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async cargarNumero() {
    let data = await this.getSolicitud();
    this.formFields.numero.value = data.bajaclinumero;
    this.formFields.fechaCreacion.value = data.bajaclifecha_alta
      ? moment(data.bajaclifecha_alta).format('YYYY-MM-DD HH:mm:ss')
      : '';
    this.formFields.usuarioCreacion.value = data.full_name;
    this.formFields.motivoTipo.value = data.motiname;
    this.formFields.cliente.value = data.cliente;
    this.formFields.observacion.value = data.bajacliobs;
    this.formFields.tramo.value = data.bajaclitramo
      ? moment(data.bajaclitramo).format('YYYY-MM')
      : '';
    this.formFields.estado.value = data.estado;
    this.formFields.autor.value = data.bajaclidetautor;
    this.formFields.equiposEsperados.value = data.bajaclidetcant_equipos;
    this.formFields.perifericosEsperados.value =
      data.bajaclidetcant_perifericos;
    this.formFields.fechaCRM.value = data.bajaclidetcrm_fecha
      ? moment(data.bajaclidetcrm_fecha).format('YYYY-MM-DD')
      : '';
    this.formFields.concepto.value = data.bajaclidetconcepto;
    this.formFields.fechaVerifica.value = data.bajaclifecha_ejecuta
      ? moment(data.bajaclifecha_ejecuta).format('YYYY-MM-DD HH:mm:ss')
      : '';
    this.formFields.nroTramiteSim.value = data.sbajasimnumero;
    this.formFields.dispositivosDetectados.value = data.equipos_confirmados;
    this.formFields.simsDetectadas.value = data.sims_confirmadas;
    this.formFields.estadoTramiteSim.value = data.estado_sim;
  }

  mounted() {
    this.cargarNumero();
  }

  formFields: {
    numero: any;
    fechaCreacion: any;
    usuarioCreacion: any;
    motivoTipo: any;
    cliente: any;
    observacion: any;
    tramo: any;
    estado: any;
    autor: any;
    equiposEsperados: any;
    perifericosEsperados: any;
    fechaCRM: any;
    concepto: any;
    fechaVerifica: any;
    nroTramiteSim: any;
    dispositivosDetectados: any;
    simsDetectadas: any;
    estadoTramiteSim: any;
  } = {
    numero: {
      label: 'Número Baja',
      value: '',
    },
    fechaCreacion: {
      label: 'Fecha Solicitud',
      value: '',
    },
    observacion: {
      label: 'Observación',
      value: '',
    },
    usuarioCreacion: {
      label: 'Usuario',
      value: '',
    },
    tramo: {
      label: 'Tramo',
      value: '',
    },
    motivoTipo: {
      label: 'Motivo',
      value: '',
    },
    cliente: {
      label: 'Cliente',
      value: '',
    },
    estado: {
      label: 'Estado',
      value: '',
    },
    autor: {
      label: 'Autor',
      value: '',
    },
    concepto: {
      label: 'Concepto',
      value: '',
    },
    equiposEsperados: {
      label: 'Equipos Esperados',
      value: '',
    },
    perifericosEsperados: {
      label: 'Periféricos Esperados',
      value: '',
    },
    fechaCRM: {
      label: 'Fecha CRM',
      value: '',
    },
    fechaVerifica: {
      label: 'Fecha Verifica',
      value: '',
    },
    nroTramiteSim: {
      label: 'Nro Tramite Sim',
      value: '',
    },
    dispositivosDetectados: {
      label: 'Dispositivos Detectados',
      value: '',
    },
    simsDetectadas: {
      label: 'Sims Detectadas',
      value: '',
    },
    estadoTramiteSim: {
      label: 'Estado Tramite Sim',
      value: '',
    },
  };

  // Globales
  $snotify: any;
  dialog: boolean = false;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  disabledAccion: boolean = false;
  mensajeConfirmacion: any = '';

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
